import React from "react";

export default () => {
    return <div className="calc_shadow"/>
}